<div *ngIf="hasMedReviewSub.asObservable() | async; then medreview; else message"></div>
<ng-template #medreview>
  <kt-portlet>
    <kt-portlet-header
      [viewLoading$]="loading$.asObservable()"
      style="display: none"
    ></kt-portlet-header>
    <kt-portlet-body style="padding: 1rem !important">
      <div *ngIf="!(loading$.asObservable() | async)" style="height: 100%">
        <kt-med-review-board-header
          [hasMedReviewSub]="hasMedReviewSub"
          [data]="data"
          [bambooHealthData]="bambooHealthData$ | async"
          (toggleViewMode)="toggleViewMode()"
          [readonly]="readonly"
        ></kt-med-review-board-header>
        <div style="height: calc(100% - 70px)">
          <kt-med-review-board-body
            *ngIf="!(subLoading$.asObservable() | async)"
            [inputData]="data"
          ></kt-med-review-board-body>
        </div>
      </div>
    </kt-portlet-body>
  </kt-portlet>
</ng-template>
<ng-template #message>
  <div class="d-flex flex-center font-weight-bold">Patient has no history of MedReviews.</div>
</ng-template>
